import { render, staticRenderFns } from "./Datastories.vue?vue&type=template&id=eee07d48&scoped=true&"
import script from "./Datastories.vue?vue&type=script&lang=js&"
export * from "./Datastories.vue?vue&type=script&lang=js&"
import style0 from "./Datastories.vue?vue&type=style&index=0&id=eee07d48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee07d48",
  null
  
)

export default component.exports